// @flow

import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontCondensed } from "@fdr/static-ui/Typography";

import MTP from "../../_atoms/MTP";
import { buildText } from "../../_atoms/Text";

export const RaceLinkContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  min-height: 40px;
  text-decoration: none;
  outline: none;
  ${({ hasMarginBorder }) =>
    hasMarginBorder &&
    css`
      margin-bottom: 12px;
    `}
  ${({ isStickyToTop }) =>
    isStickyToTop &&
    css`
      border-top: 1px solid ${buildColor("grey", "300")};
      top: 0;
      width: 100%;
      background-color: ${buildColor("white", "100")};
      z-index: 1000;
      box-shadow: 0 2px 5px ${buildColor("grey", "300")};
    `}
  position: ${({ isStickyToTop }) => (isStickyToTop ? "sticky" : "relative")};
  ${({ hasHover }) =>
    hasHover &&
    css`
      &:active {
        background-color: ${buildColor("grey", "100")};
      }
    `};
`;

export const RaceContainer = RaceLinkContainer.withComponent("div");

export const RaceMTP = styled(MTP).attrs({
  isHighlightedBellowThreshold: true
})`
  margin-bottom: 8px;
`;

export const PastRaceDate = styled.span`
  color: ${buildColor("navy", "700")};
  font-family: ${fontCondensed};
  font-size: 12px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const RaceInfo = styled.dl`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  align-self: stretch;
  margin: 0;
  flex: 1;
  overflow: hidden;

  & > time {
    ${({ useNewProgramPageLayout }) =>
      useNewProgramPageLayout ? "margin-top: 8px" : "margin-bottom: 8px"};
  }
`;

export const RaceTitle = styled(
  buildText({
    tag: "div",
    fontSize: 14,
    ellipsis: true,
    uppercase: false,
    qaLabel: "betRaceLink-raceTitle",
    color: buildColor("grey", "D4")
  })
)`
  font-family: ${fontBold};
  font-weight: 500;
  line-height: 125%;
`;

export const RaceNumber = styled(
  buildText({
    tag: "div",
    fontSize: 14,
    bold: false,
    qaLabel: "betRaceLink-raceNumber",
    color: buildColor("grey", "D4")
  })
)`
  white-space: nowrap;
  line-height: 125%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  ${({ hasExperiment }) =>
    hasExperiment &&
    css`
      position: relative;
    `}

  & > svg {
    margin-right: 8px;
  }
`;

export const Label = styled.span`
  background-color: ${buildColor("red")};
  color: ${buildColor("white")};
  padding: 2px 4px 2px 4px;
  border-radius: 2px;
  font-size: 12px;
  text-transform: uppercase;
  position: absolute;
  top: -18px;
  right: -22px;
`;
